import { Box, Spinner, useTheme } from '@chakra-ui/react';

const Loading = () => {
  const theme = useTheme();
  return (
    <Box display='flex' alignItems='center' justifyContent='center' height='100vh'>
      <Spinner color={theme.colors.purple[500]} size='xl' />
    </Box>
  );
};

export default Loading;